import { BoardSpace, SpaceType, PropertyColor } from './types.js';

export const BOARD_SPACES: BoardSpace[] = [
  // Position 0: GO
  { position: 0, name: 'GO', type: SpaceType.GO },

  // Position 1: Mediterranean Avenue
  {
    position: 1, name: 'Mediterranean Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.BROWN, price: 60,
    rent: [2, 10, 30, 90, 160, 250], houseCost: 50, mortgageValue: 30,
  },

  // Position 2: Community Chest
  { position: 2, name: 'Community Chest', type: SpaceType.COMMUNITY_CHEST },

  // Position 3: Baltic Avenue
  {
    position: 3, name: 'Baltic Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.BROWN, price: 60,
    rent: [4, 20, 60, 180, 320, 450], houseCost: 50, mortgageValue: 30,
  },

  // Position 4: Income Tax
  { position: 4, name: 'Income Tax', type: SpaceType.INCOME_TAX, amount: 200 },

  // Position 5: Reading Railroad
  { position: 5, name: 'Reading Railroad', type: SpaceType.RAILROAD, price: 200, mortgageValue: 100 },

  // Position 6: Oriental Avenue
  {
    position: 6, name: 'Oriental Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.LIGHT_BLUE, price: 100,
    rent: [6, 30, 90, 270, 400, 550], houseCost: 50, mortgageValue: 50,
  },

  // Position 7: Chance
  { position: 7, name: 'Chance', type: SpaceType.CHANCE },

  // Position 8: Vermont Avenue
  {
    position: 8, name: 'Vermont Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.LIGHT_BLUE, price: 100,
    rent: [6, 30, 90, 270, 400, 550], houseCost: 50, mortgageValue: 50,
  },

  // Position 9: Connecticut Avenue
  {
    position: 9, name: 'Connecticut Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.LIGHT_BLUE, price: 120,
    rent: [8, 40, 100, 300, 450, 600], houseCost: 50, mortgageValue: 60,
  },

  // Position 10: Jail / Just Visiting
  { position: 10, name: 'Jail', type: SpaceType.JAIL },

  // Position 11: St. Charles Place
  {
    position: 11, name: 'St. Charles Place', type: SpaceType.PROPERTY,
    color: PropertyColor.PINK, price: 140,
    rent: [10, 50, 150, 450, 625, 750], houseCost: 100, mortgageValue: 70,
  },

  // Position 12: Electric Company
  { position: 12, name: 'Electric Company', type: SpaceType.UTILITY, price: 150, mortgageValue: 75 },

  // Position 13: States Avenue
  {
    position: 13, name: 'States Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.PINK, price: 140,
    rent: [10, 50, 150, 450, 625, 750], houseCost: 100, mortgageValue: 70,
  },

  // Position 14: Virginia Avenue
  {
    position: 14, name: 'Virginia Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.PINK, price: 160,
    rent: [12, 60, 180, 500, 700, 900], houseCost: 100, mortgageValue: 80,
  },

  // Position 15: Pennsylvania Railroad
  { position: 15, name: 'Pennsylvania Railroad', type: SpaceType.RAILROAD, price: 200, mortgageValue: 100 },

  // Position 16: St. James Place
  {
    position: 16, name: 'St. James Place', type: SpaceType.PROPERTY,
    color: PropertyColor.ORANGE, price: 180,
    rent: [14, 70, 200, 550, 750, 950], houseCost: 100, mortgageValue: 90,
  },

  // Position 17: Community Chest
  { position: 17, name: 'Community Chest', type: SpaceType.COMMUNITY_CHEST },

  // Position 18: Tennessee Avenue
  {
    position: 18, name: 'Tennessee Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.ORANGE, price: 180,
    rent: [14, 70, 200, 550, 750, 950], houseCost: 100, mortgageValue: 90,
  },

  // Position 19: New York Avenue
  {
    position: 19, name: 'New York Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.ORANGE, price: 200,
    rent: [16, 80, 220, 600, 800, 1000], houseCost: 100, mortgageValue: 100,
  },

  // Position 20: Free Parking
  { position: 20, name: 'Free Parking', type: SpaceType.FREE_PARKING },

  // Position 21: Kentucky Avenue
  {
    position: 21, name: 'Kentucky Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.RED, price: 220,
    rent: [18, 90, 250, 700, 875, 1050], houseCost: 150, mortgageValue: 110,
  },

  // Position 22: Chance
  { position: 22, name: 'Chance', type: SpaceType.CHANCE },

  // Position 23: Indiana Avenue
  {
    position: 23, name: 'Indiana Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.RED, price: 220,
    rent: [18, 90, 250, 700, 875, 1050], houseCost: 150, mortgageValue: 110,
  },

  // Position 24: Illinois Avenue
  {
    position: 24, name: 'Illinois Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.RED, price: 240,
    rent: [20, 100, 300, 750, 925, 1100], houseCost: 150, mortgageValue: 120,
  },

  // Position 25: B&O Railroad
  { position: 25, name: 'B&O Railroad', type: SpaceType.RAILROAD, price: 200, mortgageValue: 100 },

  // Position 26: Atlantic Avenue
  {
    position: 26, name: 'Atlantic Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.YELLOW, price: 260,
    rent: [22, 110, 330, 800, 975, 1150], houseCost: 150, mortgageValue: 130,
  },

  // Position 27: Ventnor Avenue
  {
    position: 27, name: 'Ventnor Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.YELLOW, price: 260,
    rent: [22, 110, 330, 800, 975, 1150], houseCost: 150, mortgageValue: 130,
  },

  // Position 28: Water Works
  { position: 28, name: 'Water Works', type: SpaceType.UTILITY, price: 150, mortgageValue: 75 },

  // Position 29: Marvin Gardens
  {
    position: 29, name: 'Marvin Gardens', type: SpaceType.PROPERTY,
    color: PropertyColor.YELLOW, price: 280,
    rent: [24, 120, 360, 850, 1025, 1200], houseCost: 150, mortgageValue: 140,
  },

  // Position 30: Go To Jail
  { position: 30, name: 'Go To Jail', type: SpaceType.GO_TO_JAIL },

  // Position 31: Pacific Avenue
  {
    position: 31, name: 'Pacific Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.GREEN, price: 300,
    rent: [26, 130, 390, 900, 1100, 1275], houseCost: 200, mortgageValue: 150,
  },

  // Position 32: North Carolina Avenue
  {
    position: 32, name: 'North Carolina Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.GREEN, price: 300,
    rent: [26, 130, 390, 900, 1100, 1275], houseCost: 200, mortgageValue: 150,
  },

  // Position 33: Community Chest
  { position: 33, name: 'Community Chest', type: SpaceType.COMMUNITY_CHEST },

  // Position 34: Pennsylvania Avenue
  {
    position: 34, name: 'Pennsylvania Avenue', type: SpaceType.PROPERTY,
    color: PropertyColor.GREEN, price: 320,
    rent: [28, 150, 450, 1000, 1200, 1400], houseCost: 200, mortgageValue: 160,
  },

  // Position 35: Short Line Railroad
  { position: 35, name: 'Short Line', type: SpaceType.RAILROAD, price: 200, mortgageValue: 100 },

  // Position 36: Chance
  { position: 36, name: 'Chance', type: SpaceType.CHANCE },

  // Position 37: Park Place
  {
    position: 37, name: 'Park Place', type: SpaceType.PROPERTY,
    color: PropertyColor.DARK_BLUE, price: 350,
    rent: [35, 175, 500, 1100, 1300, 1500], houseCost: 200, mortgageValue: 175,
  },

  // Position 38: Luxury Tax
  { position: 38, name: 'Luxury Tax', type: SpaceType.LUXURY_TAX, amount: 100 },

  // Position 39: Boardwalk
  {
    position: 39, name: 'Boardwalk', type: SpaceType.PROPERTY,
    color: PropertyColor.DARK_BLUE, price: 400,
    rent: [50, 200, 600, 1400, 1700, 2000], houseCost: 200, mortgageValue: 200,
  },
];
